import Posts from "../../components/Posts";
import Sidebar from "../../components/Sidebar";

export default function Home() {
  return (
    <>
      <section className="wrapper">
        <Sidebar />
        <Posts />
      </section>
    </>
  );
}
